export default __webpack_public_path__ + "static/real-glide-gallery-608a073dddd7ba125d6355d70dc2d2c0.gif";